import TopLayoutBlog from 'docs/src/modules/components/TopLayoutBlog';
import { docs } from './introducing-mui-x-chat-v9-alpha.md?muiMarkdown';

export default function Page() {
  return <TopLayoutBlog docs={docs} />;
}
